module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp12_6000.e9235a3a.png";